/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import { ChevronDownIcon, PlusSmIcon } from '@heroicons/react/solid'
import LoadingBar from 'react-top-loading-bar'

import SimplifiedHeader from '../components/SimplifiedHeader'
import StickyHeader from '../components/StickyHeader'
import Footer from '../components/Footer'
import DealService from '../services/DealService'
import useTitle from '../hooks/useTitle'

import { DealProvider, DealContext, useDeal } from '../providers/DealProvider';

import HeroBanner from './components/HeroBanner'
import DealFilter from './components/DealFilter'
import DealGrid from './components/DealGrid'
import MarketPlaceSearch from '../components/MarketplaceSearch'

const profile = ['Your Profile', 'Settings', 'Sign out']

const navigation = {}
const breadcrumbs = [{ id: 1, name: 'Men', href: '#' }]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function HomepageApp() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [deals, setDeals] = useState([]);

  const { dealId, catSlug } = useParams();

  useTitle("Browse Savings | The Convoy | Save on everyday business expenses.");

  return (
    <div className="bg-white">
      <StickyHeader />
      <HeroBanner />
      <div className="mx-auto container xl:w-2/4 mt-2 xl:mt-0">
        <div className="mx-auto xl:w-2/4 w-full xl:-mt-6 bg-white px-6 z-10 relative xl:absolute search-bar-container">
          <MarketPlaceSearch />
        </div>
      </div>
      <DealProvider>
        <main className="mx-auto container mx-auto">
          <div className="xl:flex xl:flex-row xl:justify-between">
            <div className="xl:w-2/12 xl:mr-8 xl:pt-12">
              <DealFilter />
            </div>
            <div className="xl:pt-12 xl:pb-24 xl:w-9/12">
              
              <DealGrid deals={deals} />
            </div>
          </div>
        </main>
      </DealProvider>

      <div className="container mx-auto">
        <Footer />
      </div>
    </div>
  )
}

export default HomepageApp;
